// extracted by mini-css-extract-plugin
module.exports = {"oddBadge":"OddBadge_oddBadge__314w8","increased":"OddBadge_increased__2CQUF","decreased":"OddBadge_decreased__1T9hy"};